import type { RoleCategory } from '@/features/user-management/types'
import type { AnnouncementRoleColumn, BuildAnnouncementRoleColumnsResult } from '../types'

/**
 * Builds Liberty / PMC / Charity checkbox columns from GET `/roles` (`role_data`),
 * matching Angular NgRx `LoadUserRoles` → `filterRole` assignment logic exactly.
 */
export function buildAnnouncementRoleColumns(
  roleData: Record<string, RoleCategory>,
): BuildAnnouncementRoleColumnsResult {
  const filterRole = {
    Liberty: {
      descrption: 'Liberty',
      roles: {} as Record<string, { name: string }>,
    },
    PMC: {
      descrption: 'Property Management Companies',
      roles: {} as Record<string, { name: string }>,
    },
    Charity: {
      descrption: 'Charities',
      roles: {} as Record<string, { name: string }>,
    },
  }
  const allRoleKeys: string[] = []

  Object.keys(roleData).forEach((categoryKey) => {
    const cat = roleData[categoryKey]
    if (!cat?.roles) return

    Object.keys(cat.roles).forEach((roleKey) => {
      const roleDef = cat.roles[roleKey]
      const copy = { name: roleDef.name }

      if (cat.name === 'Charity Accounts') {
        filterRole.Charity.roles[roleKey] = copy
        allRoleKeys.push(roleKey)
      } else if (cat.name === 'Liberty Accounts') {
        filterRole.Liberty.roles[roleKey] = copy
        allRoleKeys.push(roleKey)
      } else if (categoryKey === 'COMPANY' || categoryKey === 'PROPERTY') {
        filterRole.PMC.roles[roleKey] = copy
        allRoleKeys.push(roleKey)
      } else if (categoryKey === 'OTHERS') {
        const displayName = roleDef.name === 'Resident' ? 'Applicants' : roleDef.name
        filterRole.PMC.roles[roleKey] = { name: displayName }
        allRoleKeys.push(roleKey)
      }
    })
  })

  const toRows = (roles: Record<string, { name: string }>) =>
    Object.entries(roles).map(([roleKey, r]) => ({
      roleKey,
      displayName: r.name,
    }))

  const columns: AnnouncementRoleColumn[] = [
    {
      key: 'Liberty',
      heading: filterRole.Liberty.descrption,
      roles: toRows(filterRole.Liberty.roles),
    },
    {
      key: 'PMC',
      heading: filterRole.PMC.descrption,
      roles: toRows(filterRole.PMC.roles),
    },
    {
      key: 'Charity',
      heading: filterRole.Charity.descrption,
      roles: toRows(filterRole.Charity.roles),
    },
  ]

  return { columns, allRoleKeys }
}
